import appStore from 'store'
import api from './api'
import { QUERY_TYPE, PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    topPartner: '5555',
    userList: [],
    detailList: [],
    coinList: [],
    symbolList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
    buyAmount: 0,
    sellAmount: 0,
    transferAmount: 0,
    totalProfit: 0,
    totalFee: 0,
    totalOpenOrderMarginFrozen: 0,
    totalRealizedProfit: 0,
    orderBy: null,
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice()
      state.totalCount = payload.totalCount
    },

    setPagination(state, payload) {
      state.pagination = payload
    },
    setDetailList(state, payload) {
      state.detailList = payload.page.records
      state.detailTotalCount = payload.page.total
      state.buyAmount = payload.buyAmount
      state.sellAmount = payload.sellAmount
      state.transferAmount = payload.transferAmount
    },
    setCoinList(state, payload) {
      state.coinList = payload || []
    },
    setSymbolList(state, payload) {
      state.symbolList = payload || []
    },
    setTotalInfo(state, payload) {
      state.totalProfit = payload.totalProfit //未结算盈亏汇总
      state.totalFee = payload.totalFee //手续费汇总
      state.totalOpenOrderMarginFrozen = payload.totalOpenOrderMarginFrozen //保证金汇总
      state.totalRealizedProfit = payload.totalRealizedProfit //已实现盈亏汇总
    },
    setOrderBy(state, payload) {
      state.orderBy = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          commit('setUserList', res.data)
        }
      })
    },
    addRemark({ commit }, data) {
      return api.addRemark(data).then((res) => {
        return res
      })
    },
    //汇总
    getTotalInfo({ commit }, data) {
      return api.getTotalInfo(data).then((res) => {
        if (res.code == 0) {
          commit('setTotalInfo', res.data)
        }
      })
    },
    getDetail({ commit }, data) {
      api.getDetail(data).then((res) => {
        if (res.code == 0) {
          commit('setDetailList', res.result)
        }
      })
    },
    getCoinList({ commit }, data) {
      api.getCoinList().then((res) => {
        if (res.code == 0) {
          commit('setCoinList', res.result)
        }
      })
    },
    getSymbolList({ commit }, data) {
      api.getSymbolList().then((res) => {
        if (res.code == 0) {
          commit('setSymbolList', res.data)
        }
      })
    },
  },
}

appStore.registerModule('contractPosition', store)
